import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy } from "react-table";

// import styles from "../mychargers.module.scss";
import styles from "../myReports.module.scss";

import cn from "classnames";

import BatteryProgress from "../echarts/BatteryProgress";

//import makeData from './makeData'

const Styles = styled.div`
  table {
    border-spacing: 0;
    border: 0px solid black;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th:nth-child(2) {
      position: absolute;
      left: 40px;
    }
    th {
      font: normal normal bold 18px/19px Montserrat;
      color: #000000;
      padding: 12px 10px;
    }
    td {
      margin: 0;
      border-bottom: 0px solid black;
      border-right: 0px solid black;
      font: normal normal 15px/19px Montserrat;
      //   height: 76px;
      padding: 0px 10px;
      /* The secret sauce */
      /* Each cell should grow equally */
      // width: 1%;
      /* But "collapsed" cells should be as small as possible */
      &.collapse {
        width: 0.0000000001%;
      }

      // :last-child {
      //   border-right: 0;
      // }
      .Charging {
        color: #6a9930;
      }
      .V2G {
        color: #5696ad;
      }
      .Plugged {
        color: #e5972d;
      }
      .Available {
        color: #b472b5;
      }
      .Error {
        color: #a23b3e;
      }
      .Offline {
        color: #353535;
      }
      .pluggedError {
        width: 39%;
        margin: 0 auto;
        padding-left: 10px;
      }
      .busError {
        width: 39%;
        margin: 0 auto;
        padding-left: 10px;
      }
      // :last-child {
      //   border-right: 0;
      // }
    }
  }
`;
let checkCount = 0;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    if ({ ...rest }.checked === true || indeterminate === true) {
      checkCount = 1;
      localStorage.setItem("checka", true);
    } else {
      checkCount = 0;
      localStorage.setItem("checka", false);
    }

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate, { ...rest }]);

    return (
      <>
        <label className={cn(styles.container)}>
          <input type="checkbox" ref={resolvedRef} {...rest} />
          <span className={cn(styles.checkmark)}></span>
        </label>
      </>
    );
  }
);

function Table({ columns, data, getSelectedRows }) {
  console.log("columns, data columns, data ", columns, data);
  const {
    getTableProps,
    getTableBodyProps,
    toggleRowSelected,
    toggleAllRowsSelected,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div className={cn(styles.container)}>
              {/* <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} /> */}
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox
                {...row.getToggleRowSelectedProps({
                  onChange: () => {
                    const selected = row.isSelected; // get selected status of current row.
                    toggleAllRowsSelected(false); // deselect all.
                    row.toggleRowSelected(!selected); // reverse selected status of current row.
                  },
                })}
              />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  useEffect(() => {
    // Select all rows

    rows.forEach(({ id, original }, index) => {
      // if ("isSelected" in original) {
      // Disable By Default first one selected
      // if (index == 0) {
      //   toggleRowSelected(id, original.isSelected);
      // }
      // }
    });
  }, [rows, toggleRowSelected]);

  useEffect(() => {
    getSelectedRows(selectedRowIds);
  }, [selectedRowIds]);
  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted ? (column.isSortedDesc ? "" : "") : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            // {rows.slice(0, 10).map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
// const data = [
//   {
//     charger: { name: "USD-1", port: "PowerPort 19kw" },
//   },
//   {
//     charger: { name: "USD-2", port: "PowerPort 19kw" },
//   },
//   {
//     charger: { name: "USD-3", port: "PowerPort 19kw" },
//   },
//   {
//     charger: { name: "USD-4", port: "PowerPort 19kW" },
//   },
//   {
//     charger: { name: "USD-4", port: "PowerPort 19kw" },
//   },
//   {
//     charger: { name: "USD-8", port: "PowerPort 19kw" },
//   },
//   {
//     charger: { name: "USD-9", port: "PowerPort 19kw" },
//   },
// ];
function App(props) {
  const { data, filterdatas, getSelectEvseIds } = props;
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    appendRootKeyInDataArray(data);
  }, [data]);

  const appendRootKeyInDataArray = (data) => {
    let manupulatedData = [];
    data.map((item) => {
      manupulatedData.push({
        charger: item,
      });
      setTableData(manupulatedData);
    });
  };

  useEffect(() => {
    if (filterdatas !== undefined && filterdatas.length > 0) {
      let ArrayData = data.filter((obj) =>
        props.filterdatas.some(({ value }) => obj.site.siteId === value)
      );
      appendRootKeyInDataArray(ArrayData);
    } else {
      appendRootKeyInDataArray(data);
    }
  }, [props.filterdatas]);

  function bar(val) {
    props.datas1(val);
  }
  // let ArrayData;

  // if (props.filterdatas !== undefined) {
  //   if (props.filterdatas.length > 0) {
  //     ArrayData = data.filter((obj) =>
  //       props.filterdatas.some(
  //         ({ label }) =>
  //           obj.site.replaceAll(" ", "") === label.replaceAll(" ", "") ||
  //           obj.charger.name.replaceAll(" ", "") === label.replaceAll(" ", "")
  //       )
  //     );
  //   } else {
  //     ArrayData = tableData;
  //   }
  // }

  // if (props.filterdatas !== undefined) {
  //   if (props.filterdatas.length > 0) {
  //     ArrayData = data.filter((obj) =>
  //       props.filterdatas.some(({ value }) => obj.site.siteId === value)
  //     );
  //     console.log("ArrayDataArrayData", ArrayData);
  //   } else {
  //     ArrayData = tableData;
  //   }
  // } else {
  //   ArrayData = tableData;
  // }
  const columns = React.useMemo(
    () => [
      {
        Header: "Chargers List",
        disableSortBy: false,
        accessor: "charger",
        Cell: (props) => {
          return (
            <>
              <div
                className={cn(styles.col_charger, styles.col_charger_layout2)}
              >
                <h5 className={cn(styles.h5_prop1, styles.h5_prop1_layout)}>
                  {props.value.name}
                </h5>
                <h5 className={cn(styles.h5_prop, styles.h5_prop_layout)}>
                  {props.value.site.name}
                </h5>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  return (
    <Styles>
      <Table
        columns={columns}
        data={tableData}
        getSelectedRows={(selectedRows) => {
          let selectedEvseIdArray = [];
          for (const key in selectedRows) {
            selectedEvseIdArray.push(tableData[key].charger.evseId);
          }
          // if (selectedEvseIdArray.length > 0) {
          getSelectEvseIds(selectedEvseIdArray);
          // }
        }}
      />
      {/* result===undefined?data:result */}
    </Styles>
  );
}

export default App;

// // import React, { useState } from "react";
// // // import ReactDOM from "react-dom";
// // // import { Component } from "react";
// // // import { jsx } from "@emotion/core";
// // import cn from 'classnames';
// // import styles from '../mychargers.module.scss';
// // //import Button from "@atlaskit/button";
// // import Select, { components } from "react-select";

// // import { defaultTheme } from "react-select";

// // const InputOption = ({
// //   getStyles,
// //   Icon,
// //   isDisabled,
// //   isFocused,
// //   isSelected,
// //   children,
// //   innerProps,
// //   ...rest
// // }) => {
// //   const [isActive, setIsActive] = useState(false);
// //   const onMouseDown = () => setIsActive(true);
// //   const onMouseUp = () => setIsActive(false);
// //   const onMouseLeave = () => setIsActive(false);

// //   // styles
// //   let bg = "transparent";
// //   if (isFocused) bg = "#eee";
// //   if (isActive) bg = "#B2D4FF";

// //   const style = {
// //     alignItems: "center",
// //     backgroundColor: bg,
// //     color: "inherit",
// //     display: "flex "
// //   };

// //   // prop assignment
// //   const props = {
// //     ...innerProps,
// //     onMouseDown,
// //     onMouseUp,
// //     onMouseLeave,
// //     style
// //   };

// //   return (
// //     <components.Option
// //       {...rest}
// //       isDisabled={isDisabled}
// //       isFocused={isFocused}
// //       isSelected={isSelected}
// //       getStyles={getStyles}
// //       innerProps={props}
// //     >
// //       <label className={cn(styles.customCheckbox)}>

// //         <input type="checkbox" checked={isSelected} />
// //         <span className={cn(styles.checkmarkDropdown)}></span>
// //       </label>

// //       {children}
// //     </components.Option>
// //   );
// // };

// // const options = [
// //   { value: "0", label: "Select All" },
// //   { value: "1", label: "Item 1" },
// //   { value: "2", label: "Item 2" },
// //   { value: "3", label: "Item 3" },
// //   { value: "4", label: "Item 4" },
// //   { value: "5", label: "Item 5" },
// //   { value: "6", label: "Item 6" },
// //   { value: "7", label: "Item 7" }
// // ];

// // const { colors } = defaultTheme;

// // const selectStyles = {
// //   control: (provided) => ({ ...provided, minWidth: 240, margin: 8 }),
// //   menu: () => ({ boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" })
// // };

// // // class App extends Component {
// // // var state = { isOpen: true, value: undefined };

// // // var { AppRegistry, StyleSheet, Text, View } = React;

// // //   var styles = StyleSheet.create({
// // //     content:{
// // //         flex:1,
// // //         flexDirection:'row',
// // //         alignItems:'center',
// // //         justifyContent:'center'
// // //     },
// // // });

// // // var stylesbox1 = {
// // //   border: "3px solid #fff",
// // //   padding: "0px",
// // //   minWidth: "440"
// // // };
// // ///var isopen =true;

// // // render() {
// // const ChargerTable = (props) => {

// //   const [selectedOptions, setSelectedOptions] = useState([]);
// //   const [state, setState] = useState([]);
// //   const [isOpen, setIsOpen] = useState(false);
// //   const [isCheckAll, setCheckAll] = useState(false)
// //   var toggleOpen = () => {
// //     setIsOpen((current) => !current);
// //   };
// //   var onSelectChange = (value) => {
// //     setState(value);
// //   };

// //   var stateToSelection = () => {
// //     setState(selectedOptions.filter((item) => item.value !== 0));
// //     props.chargerCallback(selectedOptions.filter((item) => item.value !== 0));
// //     setIsOpen(false)
// //   };

// //   var removeSelection = (id) => {
// //     setCheckAll(false);
// //     setSelectedOptions(selectedOptions.filter((item) => {
// //       if (item.value === 0) {
// //         selectedOptions.splice(item.value, 1);
// //       }
// //     }));
// //     // setSelectedOptions(selectedOptions.filter((item) => item.value !== "0"));
// //     setState(state.filter((item) => item.value !== id));
// //     setSelectedOptions(selectedOptions.filter((item) => item.value !== id));

// //     props.chargerCallback(selectedOptions.filter((item) => item.value !== id));
// //     if (selectedOptions.length === 2) {
// //       selectedOptions.filter((item) => {
// //         if(item.value === 0) {
// //           setSelectedOptions(null);
// //           props.chargerCallback([]);
// //         }
// //       })
// //     }
// //   };

// //   return (
// //     <Dropdown
// //       isOpen={isOpen}
// //       onClose={toggleOpen}
// //       target={
// //         <div className={cn(styles.selectDropdown)}>
// //           <button className={cn(styles.dropdownArrow)}
// //             // style={stylesbox1}
// //             iconAfter={<ChevronDown />}
// //             onClick={toggleOpen}
// //             isSelected={isOpen}
// //           >
// //             <img src={require('assets/arrowBottom.svg').default} />
// //           </button>
// //           <div className={cn(styles.data)} >
// //             {
// //               state && state.length > 0
// //                 ? state.map((opt) => {
// //                   if (opt && opt.value !== "0")
// //                     return (
// //                       <div key={opt.value} className={cn(styles.floatChild)}>
// //                         {opt.label}
// //                         <span className={cn(styles.btnCross)}
// //                           key={opt.value}
// //                           onClick={() => removeSelection(opt.value)}
// //                         >
// //                           X
// //                         </span>
// //                       </div>
// //                     );
// //                 })
// //                 : props.text === 'Select' ? 'Select' : "All"}
// //           </div>
// //         </div>
// //       }
// //     >
// //       <Select
// //         autoFocus
// //         backspaceRemovesValue={false}
// //         defaultValue={[]}
// //         isMulti
// //         closeMenuOnSelect={false}
// //         hideSelectedOptions={false}
// //         components={{
// //           Option: InputOption,
// //           DropdownIndicator,
// //           IndicatorSeparator: null
// //         }}
// //         controlShouldRenderValue={false}
// //         isClearable={false}
// //         value={selectedOptions}
// //         // value={state}
// //         menuIsOpen
// //         //onChange={onSelectChange}
// //         onChange={(options1) => {
// //           if (Array.isArray(options1)) {
// //             if (options1.some((item) => "0" === item.value)) {
// //               if (isCheckAll && props.dropdownData.length > options1.length) {
// //                 setCheckAll(false);
// //                 setSelectedOptions(options1.filter((item) => item.value !== "0"));
// //               } else if (!isCheckAll) {
// //                 setCheckAll(true);
// //                 setSelectedOptions(props.dropdownData.map((opt) => opt));
// //               }
// //             } else {
// //               if (isCheckAll) {
// //                 setCheckAll(false);
// //                 setSelectedOptions(null)
// //               } else if (props.dropdownData.length === (options1.length + 1)) {
// //                 setSelectedOptions(props.dropdownData.map((opt) => opt));
// //                 setCheckAll(true);
// //               } else {
// //                 setSelectedOptions(options1.map((opt) => opt));
// //               }
// //               // setSelectedOptions(options1.map((opt) => opt));
// //             }
// //           }
// //         }}
// //         options={options}
// //         placeholder="Search..."
// //         styles={selectStyles}
// //         tabSelectsValue={false}
// //       // value={state.value}
// //       />
// //       <button className={cn(styles.btnOk)} onClick={() => stateToSelection()}>OK</button>
// //     </Dropdown>
// //   );
// // };
// // // }

// // export default ChargerTable;

// // // styled components

// // const Menu = (props) => {
// //   // const shadow = "hsla(218, 50%, 10%, 0.1)";

// //   return (

// //     <div className={cn(styles.containerDataSection)}

// //       {...props}
// //     />

// //   );
// // };
// // const Blanket = (props) => (
// //   <div

// //     {...props}
// //   />
// // );
// // const Dropdown = ({ children, isOpen, target, onClose }) => (
// //   <div className={cn(styles.mainContainer)}>
// //     {target}
// //     {isOpen ? <Menu>{children}</Menu> : null}
// //     {isOpen ? <Blanket onClick={onClose} /> : null}
// //   </div>
// // );
// // const Svg = (p) => (
// //   <svg
// //     width="24"
// //     height="24"
// //     viewBox="0 0 24 24"
// //     focusable="false"
// //     role="presentation"
// //     {...p}
// //   />
// // );
// // const DropdownIndicator = () => (
// //   <div className={cn(styles.colorText)} css={{ color: colors.neutral20, height: 24, width: 32 }}>
// //     <Svg>
// //       <path
// //         d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
// //         fill="currentColor"
// //         fillRule="evenodd"
// //       />
// //     </Svg>
// //   </div>
// // );
// // const ChevronDown = () => (
// //   <Svg style={{ marginRight: -6 }}>
// //     <path
// //       d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z"
// //       fill="currentColor"
// //       fillRule="evenodd"
// //     />
// //   </Svg>
// // );

// // // const rootElement = document.getElementById("root");
// // // ReactDOM.render(<App />, rootElement);

// import "bootstrap/dist/css/bootstrap.min.css";
// import React, { useEffect, useState } from "react";
// // import YTVideo from "./YTVideo";

// // const userData = [
// //   { name: "Jeevan" },
// //   { name: "Manish" },
// //   { name: "Prince" },
// //   { name: "Arti" },
// //   { name: "rahul" }
// // ];

// const userData = [
//   // { value: "0", name: "Select All" },
//   { value: "1", name: "USD-1", 'port': 'PowerPort 19kw' },
//   { value: "2", name: "USD-2", 'port': 'PowerPort 19kw' },
//   { value: "3", name: "USD-3", 'port': 'PowerPort 19kw' },
//   { value: "4", name: "USD-4", 'port': 'PowerPort 19kw' },
//   { value: "5", name: "USD-5", 'port': 'PowerPort 19kw' },
//   { value: "6", name: "USD-6", 'port': 'PowerPort 19kw' },
//   { value: "7", name: "USD-7", 'port': 'PowerPort 19kw' }
// ];

// function App(props) {
//   const [users, setUsers] = useState([]);
//   const [checkBox, setCheckBox] = useState(false);
//   useEffect(() => {
//     setUsers(userData);
//   }, []);

//   props.datas1(checkBox)

//   const handleChange = (e) => {
//     const { name, checked } = e.target;
//     if (name === "allSelect") {
//       let tempUser = users.map((user) => {
//         return { ...user, isChecked: checked };
//       });
//       setUsers(tempUser);
//     } else {

//       let tempUser = users.map((user) =>
//         user.name === name ? { ...user, isChecked: checked } : user
//       );
//       setUsers(tempUser);
//     }
//   };

//   // props.datas2()

//   useEffect(() => {
//     if(users){
//       let checkValue = users.find((val) => val.isChecked === true)
//       checkValue?.isChecked === true ? setCheckBox(true) : setCheckBox(false);
//     }
//   }, [users]);

//   return (
//     <div className="container my-4" style={{ width: "500px" }}>
//       <form className="form w-100">
//         {/* <h3>Select Users</h3> */}
//         <div className="form-check">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             name="allSelect"
//             // checked={
//             //   users.filter((user) => user?.isChecked !== true).length < 1
//             // }
//             checked={!users.some((user) => user?.isChecked !== true)}
//             onChange={handleChange}
//           />
//           <label className="form-check-label ms-2">Chargers List</label>
//         </div>
//         {users.map((user, index) => (
//           <div className="form-check" key={index}>
//             <input
//               type="checkbox"
//               className="form-check-input"
//               name={user.name}
//               checked={user?.isChecked || false}
//               onChange={handleChange}
//             />
//             <label className="form-check-label ms-2">{user.name}</label>
//           </div>
//         ))}
//       </form>
//       {/* <YTVideo embedId="mGV9r0wgCrI" /> */}
//     </div>
//   );
// }

// export default App;
